// extracted by mini-css-extract-plugin
export default {"root":"JumboBanner_root__1CTnW","container":"JumboBanner_container__3um9O","content":"JumboBanner_content__1DXqe"};